import { Component } from '@angular/core';
import { ArticleModel } from 'src/app/blog/ng-store/model/article.model';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class AboutComponent {
  heading = 'About us';
  description = [
    'Our partnership, our model, and our mission.',
    'Find out what makes us unique!'
  ];
  breadcrumbs = [{
    link: '/home',
    ariaLabel: 'Go back to home page',
    label: 'Home'
  }, {
    link: '',
    ariaLabel: '',
    label: 'About us'
  }];
}
